import * as React from "react";

export const DeleteIcon = ({ ...props }) => {
  return (
    <svg
      width={12}
      height={11}
      viewBox="0 0 12 11"
      fill="none"
      cursor="pointer"
      {...props}
    >
      <path
        d="M1.5 3.438h9M4.313 1h3.375M2.625 3.438V10h6.75V3.437"
        stroke="#F66"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
